import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image, ImageSize } from '@as/cotopaxi';
import { Box, Stack, TextAlpha } from '@yonderland/andes-react';
const ProductFeature = ({ feature }) => {
    return (_jsxs(Stack, { wrap: "nowrap", align: "center", gap: "2", children: [_jsx(Box, { flex: { shrink: 0 }, children: _jsx(Image, { src: feature.icon, size: ImageSize.PRODUCT_FEATURE }) }), _jsxs("div", { children: [_jsx(TextAlpha, { strong: true, children: typeof feature.featureValue === 'string'
                            ? feature.title.replace('{value}', feature.featureValue)
                            : feature.title }), _jsx(TextAlpha, { children: feature.description })] })] }));
};
export default ProductFeature;
